import { useState } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

interface IProps {
    ssnDecrypted: string | null | undefined;
    fallback?: string;
    asTd?: boolean;
}

const digitsOnly = (ssn: string): string => ssn.replace(/\D/g, '');

const lastFourOfSsn = (ssn: string): string => {
    const digits = digitsOnly(ssn);
    if (digits.length < 4) return digits ? '***-**-' + digits : '';
    return '***-**-' + digits.slice(-4);
};

const formatSsn = (ssn: string): string => {
    const digits = digitsOnly(ssn);
    if (digits.length !== 9) return digits;
    return digits.slice(0, 3) + '-' + digits.slice(3, 5) + '-' + digits.slice(5, 9);
};

const isValidSsn = (ssn: string | null | undefined): boolean =>
    ssn != null && digitsOnly(ssn).length === 9;

export const SsnDisplay = (props: IProps) => {
    const { ssnDecrypted, fallback = 'N/A', asTd = false } = props;
    const [showFull, setShowFull] = useState(false);

    if (!isValidSsn(ssnDecrypted)) {
        return asTd ? <td>{fallback}</td> : <span>{fallback}</span>;
    }

    const ssn = ssnDecrypted!;
    const display = showFull ? formatSsn(ssn) : lastFourOfSsn(ssn);

    const content = (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontVariantNumeric: 'tabular-nums' }}>
            {display}
            <Button
                bsStyle="link"
                bsSize="xsmall"
                onClick={() => setShowFull(!showFull)}
                style={{ padding: 0, verticalAlign: 'baseline', fontSize: 'inherit', lineHeight: 1 }}
                aria-label={showFull ? 'Hide SSN' : 'Show SSN'}
                title={showFull ? 'Hide SSN' : 'Show SSN'}
            >
                <Glyphicon glyph={showFull ? 'eye-close' : 'eye-open'} />
            </Button>
        </span>
    );

    return asTd ? <td>{content}</td> : content;
};
